export enum ApplyLinkStringType {
  URL = 'url',
  EMAIL = 'email',
  OTHER = 'other',
}

export const removeJSXFromText = (text: string): string => {
  return text.replace(/<[^>]*>?/gm, '');
};

export const classifyStringType = (input: string): ApplyLinkStringType => {
  const trimmedString = input.trim();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (emailRegex.test(trimmedString)) {
    return ApplyLinkStringType.EMAIL;
  }

  try {
    new URL(trimmedString);
    return ApplyLinkStringType.URL;
  } catch {
    return ApplyLinkStringType.OTHER;
  }
};

export const checkIfStringIsValidURL = (input: string): boolean => {
  // Examples it matches:
  //    http://example.com
  //    https://example.com
  //    https://www.example.com/path?query=123#hash
  //    www.example.com
  //    example.com
  //
  // Examples it does not match:
  //    htp://example.com (wrong protocol)
  //    example (no domain or TLD)
  //    http:// (incomplete)

  const urlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
  return urlRegex.test(input);
};
